'use client';
var root = globalThis;
// A compile-time error will occur if a new field is added to the StateHelper
// interface but not included in the keys array of state helper.
var stateHelpersKeys = [
    "initFunc",
    "onChangeArgsToValue",
    "onMutate",
];
if (root.__PlasmicComponentRegistry == null) {
    root.__PlasmicComponentRegistry = [];
}
function registerComponent(component, meta) {
    // Check for duplicates
    if (root.__PlasmicComponentRegistry.some(function (r) {
        return r.component === component && r.meta.name === meta.name;
    })) {
        return;
    }
    root.__PlasmicComponentRegistry.push({ component: component, meta: meta });
}

export { registerComponent as default, stateHelpersKeys };
//# sourceMappingURL=index.esm.js.map
